import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import P from 'ia.react.p';
import {ICONS} from 'ia.react.iconlist';

import Ul from 'ia.react.ul';


//Taken from ia.react.progressbar. Removed href link in steps. Removed formatting that indicates link is active for each step
const ProgressBarContainer = styled.div`

	> ul{padding-left:0; margin:20px 0;}
	> ul li{
		position:relative;
		list-style:none;
		display:inline;
		margin-right:15px;
        text-decoration:none;

		&:after{
		  content: " ";
		  position:absolute;
		  right:-15px;
		  top:50%;
		  width:15px;
		  height:3px;
		  background:#f2f2f2;
		  display:block;
          z-index:1;
          text-decoration:none;
		}

		a{
		  position:relative;
		  border:3px solid #f2f2f2;
		  background:#f2f2f2;
		  color:#ccc;
		  text-decoration:none;
		  z-index:2;
		  font-weight:bold;
		  cursor:default;
		}

		&.done:after{background-color:#2062d4;}
		&:last-child:after{display:none;}
		&.done a{
			border:3px solid #2062d4;
			background:#2062d4;
			color:#fff;
            cursor:default;   
            text-decoration:none;        
			
			&:hover{
				background:#003da5;
                border-color:#003da5;
                text-decoration:none;
			}
		}
		

		&.active a{
		  border:3px solid #2062d4;
		  background:#fff;
		  color:#2062d4;
          cursor:default;
          text-decoration:none;
		}
	}
	
	> ul li.active:last-child a{
        border-color:#2062d4;
        text-decoration:none;
	}
	
	> ul li a{
		font-family: "Open Sans Bold", arial;
		font-size:18px;
		box-sizing:content-box;
		display:inline-block;
		height:40px;
		width:40px;
		line-height:40px;
		border-radius:90px;
        text-align:center;
        text-decoration:none;
	}
	
	> p{
		font-size:1.4em;
		margin:20px 0;
		font-family: "Open Sans", arial;
        line-height:2em !important;
        text-decoration:none;
	}
	
	> p strong{ font-family: "Open Sans Bold", arial; text-decoration:none; }
  
	// Small devices
	@media (max-width: 767px) {
		> ul{display:none;}
		> p{display:block;}
	}
	
	// Table & Desktop
	@media (min-width: 767px) {
		> ul{display:block;}
		> p{display:none;}
	}
`;

class ProgressBarTemp extends Component{
  constructor(props) {
    super(props);
  }
  
  handleClick(e){
    //trigger a re-render of the component.
    this.setState(() => {});
  }

  render(){
    const { currentStepIndex, steps, lang, disableAllStepsOnLastStep } = this.props;
	
    const List = steps.map(function(item, i){
		i++;

		let stepState = ((i === currentStepIndex) ? "active" : "") || ((currentStepIndex > i) ? (currentStepIndex === steps.length && disableAllStepsOnLastStep ? "" : "done") : "");
		//let stepHref = (currentStepIndex > i) ? (currentStepIndex === steps.length && disableAllStepsOnLastStep ? "javascript:void(0)" : item) : "javascript:void(0)";
		
		return <li className={stepState} key={i}>
		  <a >
			{(i === steps.length) ? <svg width="27px" height="27px" style={{position:"relative", top:"6px", right:"4px"}} viewBox="0 0 1024 1024"> <path d={ICONS["CHECK"]} fill={(currentStepIndex === steps.length) ? "#2062d4": (currentStepIndex > steps.length) ? "#fff" : "#ccc"}></path></svg> : i}
		  </a>
		</li>
    }.bind(this));
	
	const ListMobile = <span>{lang === "en" ? "Step" : "Étape"} <strong>{currentStepIndex}</strong> {lang === "en" ? "of" : "de"} <strong>{steps.length}</strong></span>;
	
    return (
	  <ProgressBarContainer>
		<Ul>{List}</Ul>
		
		<P>{ListMobile}</P>
	  </ProgressBarContainer>
    )
  }
}

ProgressBarTemp.propTypes = {
  currentStepIndex: PropTypes.number.isRequired || PropTypes.object.isRequired,
  steps: PropTypes.array.isRequired,
};

export default ProgressBarTemp;
